/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppMediaHeaderSchema } from "@schemas/message/whatsAppMediaTypeSchema";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// refer to WhatsAppResponseMessageReplyButtonsNoHeaderExport
export const whatsAppResponseQuickReplySchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("quick-reply"),
  body: z.string().nullable().optional(),
  footer: z.string().optional(),
  buttons: z.array(z.string()).optional(),

  // Optional media header (WhatsAppResponseMessageReplyButtonsMediaHeaderExport)
  ...whatsAppMediaHeaderSchema.shape,

  // Optional header (WhatsAppResponseMessageReplyButtonsTextHeaderExport)
  header_text: z.string().nullable().optional(),
});
